// import React from 'react';

// export default React.lazy(() => import('./Home'));

import Home from './Home';

export default Home;
